module.exports = __webpack_public_path__ + "img/eos.73b4470d.png";